import React from "react";
import { FaBolt, FaEnvelope, FaWhatsapp, FaClock, FaCodeBranch, FaGlobe } from "react-icons/fa";

const NODE_TYPES = [
  { type: "eventTrigger", label: "Event Trigger", icon: FaBolt, color: "#059669", description: "When an event occurs" },
  { type: "sendEmail", label: "Send Email", icon: FaEnvelope, color: "#2563eb", description: "Send HTML email" },
  { type: "sendWhatsApp", label: "Send WhatsApp", icon: FaWhatsapp, color: "#16a34a", description: "Send WhatsApp message" },
  { type: "delay", label: "Delay", icon: FaClock, color: "#d97706", description: "Wait before next step" },
  { type: "condition", label: "Condition", icon: FaCodeBranch, color: "#7c3aed", description: "Branch on condition" },
  { type: "httpRequest", label: "HTTP Request", icon: FaGlobe, color: "#0891b2", description: "Call external API" },
];

export default function AutomationNodePalette({ nodes, onAddNode }) {
  const onDragStart = (e, nodeType) => {
    e.dataTransfer.setData("application/reactflow", nodeType);
    e.dataTransfer.effectAllowed = "move";
  };

  return (
    <div className="space-y-1.5">
      <p className="text-xs font-medium text-ink-secondary px-1 mb-2">Drag to canvas or click to add</p>
      {NODE_TYPES.map((nt) => (
        <div
          key={nt.type}
          draggable
          onDragStart={(e) => onDragStart(e, nt.type)}
          onClick={() => onAddNode?.(nt.type)}
          className="flex items-center gap-2.5 px-3 py-2 rounded-lg border border-surface-border bg-surface-card hover:bg-surface-bg cursor-grab active:cursor-grabbing transition-colors"
        >
          <div className="w-7 h-7 rounded-md flex items-center justify-center flex-shrink-0" style={{ background: `${nt.color}15` }}>
            <nt.icon size={12} style={{ color: nt.color }} />
          </div>
          <div className="min-w-0">
            <p className="text-xs font-medium text-ink-primary">{nt.label}</p>
            <p className="text-2xs text-ink-muted">{nt.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

export { NODE_TYPES };
